"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStreetVsNeighboringLines = void 0;
const turf = __importStar(require("@turf/turf"));
// TODO Update Types
function getAverageCoordinate(...points) {
    let totalLatitude = 0;
    let totalLongitude = 0;
    points.forEach((coordinate) => {
        totalLatitude += coordinate[0];
        totalLongitude += coordinate[1];
    });
    return [totalLatitude / points.length, totalLongitude / points.length];
}
function getDistanceBetweenPoints(pointA, pointB) {
    const a = pointA[0] - pointB[0];
    const b = pointA[1] - pointB[1];
    return a * a + b * b;
}
// @ts-ignore
function getStreetLines(streetCoordinates, parcelLines) {
    /**
     * Checks to see if the midpoint of each parcel line overlaps a buffered neighboring line
     * if it does, we know that it is likely a neighbor-facing line
     *
     * @param parcelLines
     * @param neighborParcels
     * @param map - leaflet instance
     * @param L - for creating leaflet items
     * @param shouldShowLines - development only! set to true to see the colored lines in development mode
     * @returns - Array of street facing lines
     *
     * Why?
     * This allows us to give it a setback different to that of the street-facing line
     *  */
    // @ts-ignore
    let closestParcelLineToStreet = null;
    let closestDistance = Number.MAX_SAFE_INTEGER;
    const streetCoordinatesArr = [streetCoordinates.lng, streetCoordinates.lat];
    // @ts-ignore
    parcelLines.forEach((parcelLine) => {
        const midPoint = getAverageCoordinate(...parcelLine.geometry.coordinates);
        // @ts-ignore
        const distance = getDistanceBetweenPoints(streetCoordinatesArr, midPoint);
        if (closestDistance > distance) {
            closestDistance = distance;
            closestParcelLineToStreet = parcelLine;
        }
    });
    // @ts-ignore
    const parcelLinesNextToNeighbors = parcelLines.filter((parcelLine) => {
        // @ts-ignore
        return parcelLine.id !== closestParcelLineToStreet.id;
    });
    // @ts-ignore
    const streetSideLines = parcelLines.filter((l) => {
        // @ts-ignore
        return !parcelLinesNextToNeighbors.some((npLine) => npLine.id === l.id);
    });
    return { streetSideLines, parcelLinesNextToNeighbors };
}
// @ts-ignore
function getStreetVsNeighboringLines(streetCoordinates, parcelBoundary) {
    /**
     * Checks to see if the midpoint of parcel each line overlaps a buffered neighboring line
     * if it does, we know that it is likely a neighbor-facing line
     *  */
    try {
        if (parcelBoundary && streetCoordinates) {
            const parcelLines = turf.lineSegment(parcelBoundary).features;
            return getStreetLines(streetCoordinates, parcelLines);
        }
    }
    catch (e) {
        console.log(e);
    }
    return null;
}
exports.getStreetVsNeighboringLines = getStreetVsNeighboringLines;
//# sourceMappingURL=streets.js.map